import * as React from "react"
import posthog from "posthog-js"
import "@fortawesome/fontawesome-free/css/all.min.css"
import "./src/styles/global.css"
import { AuthProvider } from "./src/context/auth-context"

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <AuthProvider>{element}</AuthProvider>
)

export const onClientEntry = () => {
  const posthogKey = process.env.GATSBY_POSTHOG_KEY
  const posthogHost = process.env.GATSBY_POSTHOG_HOST || "https://eu.i.posthog.com"

  if (posthogKey) {
    posthog.init(posthogKey, {
      api_host: posthogHost,
      person_profiles: "always",
    })
  }
}
